export default {"src":"/assets/_next/static/media/ro.fad43f57.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};